module.exports = __webpack_public_path__ + "img/6.6451f127.png";